import { render, staticRenderFns } from "./CertificateMedellin.vue?vue&type=template&id=91ee096c&scoped=true"
import script from "./CertificateMedellin.vue?vue&type=script&lang=js"
export * from "./CertificateMedellin.vue?vue&type=script&lang=js"
import style0 from "./CertificateMedellin.vue?vue&type=style&index=0&id=91ee096c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91ee096c",
  null
  
)

export default component.exports